import React, { useEffect, useState } from 'react';
import { Table, Alert, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaDownload } from 'react-icons/fa';
import { postDataLogin, postData } from '../ApiServices/ApiService';
import NavHeader from './NavHeader';
import LatestInterviews from './LatestInterviews';

const InterviewsTabPage = () => {
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [latestInterviewsList, setLatestInterviewsList] = useState([]);
  const aminInfo = JSON.parse(localStorage.getItem('ai-admin'));

  useEffect(() => {
    clickltsInterview()
  }, [])

  const clickltsInterview = async () => {
    setSuccess('');
    const payload = {
      "user_id": aminInfo?.user_id,
      "from_date": "",
      "to_date": ""
    };
    
    setLoading(true)
    // return
    try {
      await postData('admin_in/candidate-interview/get-interview-query', payload).then(resp => {
        resp.json().then(respData => {
          if (resp.status === 200) {
            if (respData.statusCode === 200) {
              if (respData.message.toLowerCase() === 'success') {
                setLatestInterviewsList(respData.dataJ);
                setLoading(false);
                //setSuccess(resp.info);
              } else {
                setLoading(false);
                setSuccess(respData.info);
              }

            } else if (respData.statusCode === 500) {
              setLoading(false);
              setSuccess(respData.info);
            } else {
              setLoading(false);
              setSuccess('Test Details failed. Please check your credentials.');
            }
          }
          else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
            console.log('resp status else if : ', resp.status);
            if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
              || respData.message === 'Access Denied') {
              setLoading(false);
              //   callRefreshTokenApi('getSfeBatch', '');
            }
            setSuccess('Looks Like Session Expired Please login..');
          } else {
            console.log('resp status else  : ', resp);
            setLoading(false);
          }
        }).catch((error) => {
          setSuccess('Network Error');
          console.log('network error:', error);
          setLoading(false);
        });
      }).catch((error) => {
        setLoading(false);
        setSuccess('Interview Details failed. Please check your credentials or Network Error');
        console.log('network error:', error);

      });
    } catch (error) {
      setLoading(false);
      // Handle login error, e.g., display an error message to the user.
      console.error('Login failed', error);
    }
  }



  return (<>
    <NavHeader />
    <div className='page-title-heading'>Latest Interview Details</div>
    <div className='interview-list-div'><LatestInterviews data={latestInterviewsList} /></div>
    {loading && (
      <div className="spinner-overlay">
        <Spinner animation="border" role="status">
          <span className="sr-only"></span>
        </Spinner>
      </div>
    )}
  </>
  );
};

export default InterviewsTabPage;
